import { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import { GRID_ITEM_LABEL_COLOR, GRID_ITEM_VALUE_COLOR } from '../constants';
import { GridItemRow } from '../types';

interface Props {
  rows: GridItemRow[];
}

export const GridItemRows: FC<Props> = ({ rows }) => (
  <Stack direction='column' spacing={0.5} flex={1}>
    {rows.map((row) => (
      <Stack direction='row' gap={0.5} key={row.label}>
        <Typography
          sx={{
            fontSize: '1.7rem',
            fontWeight: 400,
            color: GRID_ITEM_LABEL_COLOR,
          }}
        >
          {row.label}:
        </Typography>
        <Typography
          sx={{
            fontSize: '1.8rem',
            fontWeight: 700,
            color: GRID_ITEM_VALUE_COLOR,
          }}
        >
          {row.value}
        </Typography>
      </Stack>
    ))}
  </Stack>
);
